import { Searching } from './strings.locstring.json';
import loc from 'owa-localize';
import type CalendarSearchResultsStore from './schema/CalendarSearchResultsStore';

import { CalendarSearchListViewState } from './schema/CalendarSearchListViewState';
import { createStore } from 'satcheljs';
import './mutators/setFetchingFullItemMutator';
import './mutators/initSearchResultsMutator';
import './mutators/setSearchResultsEditedMutator';
import './mutators/setCalendarSearchResultsMutator';
import './mutators/setPastDateMarkerMutator';
import './mutators/setAutoScrollItemIdMutator';
import './mutators/setHideNotificationMutator';
import './mutators/setItemUnavailableMutator';
import './mutators/setSearchModeMutator';
import './mutators/setSearchTermsMutator';
import './mutators/setReadingPaneItemIndexMutator';

let calendarSearchResultsStoreData: CalendarSearchResultsStore = {
    searchMode: CalendarSearchListViewState.Loading,
    emptyListContents: {
        icon: require('owa-empty-state/lib/svg/colored/searching.svg'),
        mainMessage: loc(Searching),
    },
    searchResults: [],
    autoScrollItemId: undefined,
    selectedItemId: undefined,
    isPastDayFound: false,
    currentInstrumentationContext: null,
    fetchingFullItem: false,
    hideNotificationBar: false,
    editedResultsCount: 0,
    searchTerms: [],
};

export default createStore<CalendarSearchResultsStore>(
    'calendarSearchResultsStore',
    calendarSearchResultsStoreData
);
